// extracted by mini-css-extract-plugin
export default {"label":"ProgressBar_label__TkxiC","outer":"ProgressBar_outer__vJIuo","inner":"ProgressBar_inner__6ZsqF"};